// The phone's top bar tucks away as you scroll down the page and comes back as soon as you scroll up, as in a
// phone's own apps. A few pixels of drift either way don't count, and neither does a scroll bouncing past the top or
// bottom of the page: the bounce back from the bottom would otherwise read as scrolling up.

export type BarScroll = { hidden: boolean; anchor: number }

// How far the page has to move one way before the bar follows.
const NUDGE = 8

export function barOnScroll(was: BarScroll, y: number, furthest: number, barHeight: number): BarScroll {
  // Near the top there's nothing under the bar to make room for.
  if (y <= barHeight) return { hidden: false, anchor: Math.max(0, y) }
  if (y > furthest) return was
  // Moving the same way the bar already went: keep the anchor with the page, so turning back counts from here.
  if (was.hidden ? y > was.anchor : y < was.anchor) return { hidden: was.hidden, anchor: y }
  if (Math.abs(y - was.anchor) < NUDGE) return was
  return { hidden: y > was.anchor, anchor: y }
}
